import { post } from './utils'

class UnsubscribeApi {
  // The address is sent explicitly. The endpoint used to derive it from the
  // bearer token, which meant following someone else's unsubscribe link
  // unsubscribed whoever was signed in -- and left a recipient with no account
  // unable to unsubscribe at all.
  static create(email) {
    return post(`/unsubscribe`, { body: JSON.stringify({ email }) })
  }
}

export default UnsubscribeApi
